import { Injectable, Optional, Inject } from '@angular/core';
import { InjectionToken } from '@angular/core';

export const ResouceNameToken = new InjectionToken<string>("ResouceNameInjectionToken");

declare var FMSResources: any;
@Injectable()
export class ResourceService {

    constructor(@Optional() @Inject(ResouceNameToken) public resource: string) {

    }

    public transform(key: string) {
        return this.Localize(this.resource, key) || this.Localize(key);
    }

    public Localize(resourceName: string, key: string = void 0): string {

        if (!key) {
            return FMSResources[resourceName];
        }
        return eval(resourceName + "Resources." + key);
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/resource.service.ts